import * as React from 'react';

const warnText =
  'Are you sure you want to leave this page? Your progress will not be saved.';

export const useWarnOnUnload = (shouldWarn) => {
  React.useEffect(() => {
    const onBeforeUnload = (e) => {
      if (shouldWarn) {
        // Need to set returnValue property instead of returning for Chrome and Safari
        e.returnValue = warnText;
      }
    };

    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [shouldWarn]);
};
